import { getMissingHseDetails } from "features/healthlink/utils/hsePatientReadiness";
import { RECEIVING_HOSPITAL_MISSING_FIELD } from "features/pregnancy/utils/receivingHospital";

// Patient-record details MN-CMS cannot be built without. A patient may now be saved
// with no date of birth or gender (KIN-1733), but MncmsMessageBuilder sets PID.7 from
// the one and PID.8 from the other, so the send has nothing to put there.
//
// Reported through the same list as the clinical fields rather than as a second notice:
// the GP already reads one "Required: ..." line before the Send button, and splitting
// the reasons across two places makes neither complete.
const getMissingPatientMncmsFields = (patient) =>
  getMissingHseDetails(patient).map(({ field }) =>
    field === "gender"
      ? "Patient gender (edit patient)"
      : "Patient date of birth (edit patient)"
  );

/*
 * Without a receiving facility code the backend refuses the send outright ("no receiving facility
 * code for MSH.6"), so offering the send at all only produces a failure the GP has to interpret.
 * It belongs in the same list as every other prerequisite (KIN-2031).
 */
const getMissingPregnancyMncmsFields = (pregnancy) => {
  const missing = [];

  if (!pregnancy?.eddMethod) missing.push("EDD Method (edit pregnancy)");
  if (!pregnancy?.receivingFacilityCode) missing.push(RECEIVING_HOSPITAL_MISSING_FIELD);

  return missing;
};

/*
 * Gestation is deliberately NOT required. The backend stopped emitting the gestational-age OBXs in
 * KIN-2048 — they are not in MN-CMS v0.18 Table 1, and section 4 has the receiving system derive
 * gestation from the Agreed EDD, which we do send — and it dropped the matching validation,
 * because a GP could be blocked from sending without a field no message carried. This list kept
 * blocking on it for a while longer; it no longer does.
 */
export const getMissingAntenatalMncmsFields = (formValues, pregnancy, patient) => {
  const missing = [
    ...getMissingPatientMncmsFields(patient),
    ...getMissingPregnancyMncmsFields(pregnancy),
  ];

  if (!formValues.bloodPressureSystolic) missing.push("Systolic BP");
  if (!formValues.bloodPressureDiastolic) missing.push("Diastolic BP");
  if (!formValues.urinalysisGlucose) missing.push("Glucose");

  return missing;
};

export const getMissingPostnatalMncmsFields = (pregnancy, patient) => [
  ...getMissingPatientMncmsFields(patient),
  ...getMissingPregnancyMncmsFields(pregnancy),
];
